import { GenericResultModel } from "./base";

export interface GetProjectListResultModel extends GenericResultModel {
  projectList: ProjectListItem[];
}

export interface GetProjectResultModel extends GenericResultModel {
  project: ProjectItem;
}

export interface ProjectItem {
  id: number;
  siteId: number;
  nr: string;
  title: string;
  status: string;
}

export interface ProjectListItem {
  id: number;
  siteId: number;
  nr: string;
  title: string;
  status: string;
  phase: string;
  step: string;
  partner: string;
  epc: string;
  kWp: string;
  areaType: string;
  areaSize: string;
  lastEdit: string; // date time
  latitude: string;
  longitude: string;
  isFavorite: boolean;
  isMyProject: boolean;
  milestoneId?: number;
  phaseId?: number;
  projectTrafficMilestoneItems?: ProjectTrafficMilestoneItem[];
}

export interface ProjectTrafficMilestoneItem {
  milestoneId?: number;
  milestoneName: string;
  dueDate?: Date;
  trafficGroup?: number;
}

export enum ProjectStatus {
  INACTIVE = "Inaktiv",
  ACTIVE = "Aktiv",
  COMPLETED = "Abgeschlossen",
  CANCELED = "Abgebrochen",
}
